import request from './request'

const enterpriseToOneApi = {
  saveEnterpriseToOne (data) {
    return request.post('/enterpriseToOne', data)
  },
  updateEnterpriseToOne (id, data) {
    return request.put('/enterpriseToOnes/' + id, data)
  },
  deleteEnterpriseToOne (id) {
    return request.delete('/enterpriseToOnes/' + id)
  },
  getEnterpriseToOne (id) {
    return request.get('/enterpriseToOnes/' + id)
  },
  listEnterpriseToOne (params) {
    return request.get('/enterpriseToOnes', { params })
  },
}

export default enterpriseToOneApi
